import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'

const BackIcon = () => (
  <svg aria-hidden='true' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path d='M5.06277 9.20062L9.13203 5.13137L8.00066 4L2 10.0006L8.00066 16.0013L9.13204 14.87L5.06271 10.8006H17.9963V9.20062H5.06277Z' fill='black' />
  </svg>
)

export default function BackButton ({ children = 'Back', fallback, showOnlyWhenCanGoBack = false, iconOnly = false, ...buttonProps }) {
  const navigate = useNavigate()
  const canGoBack = (window.history.state?.idx || 0) > 0

  if (showOnlyWhenCanGoBack && !canGoBack) return null

  return (
    <Button
      {...buttonProps}
      icon={buttonProps.icon || <BackIcon />}
      onClick={() => {
        if (canGoBack) navigate(-1)
        else if (fallback) navigate(fallback)
      }}
    >
      {iconOnly ? null : children}
    </Button>
  )
}
